export const GTM_EVENT_NAME = {
    LOGIN_SUCCESS: 'app_login_success',
    LOGIN_FAILURE: 'app_login_failure',
    DATA_BLEND_UPDATED: 'app_data_blend_updated',
    SUCCESSFUL_ADVANCED_CONNECTION: 'app_successful_advanced_connection',
    CUSTOM_CONNECTOR_REQUESTED: 'app_custom_connector_requested',
    FLEXIBLE_CONNECTION_CONNECTED: 'app_flexible_connection_connected',
    CONNECTION_INCOMPLETE: 'app_connection_incomplete',
    DATA_STREAM_CREATED: 'app_data_stream_created',
    ACCOUNT_DISCONNECTED: 'app_account_disconnected',
    ACCOUNT_RECONNECTED: 'app_account_reconnected',
};

export const gtm = {
    logEvent(eventName, payload = {}) {
        if (
            process.env.NODE_ENV === 'development' ||
            // TODO: change to process.env.VUE_APP_TRACKING_MODE after testing
            process.env.VUE_APP_GTM_TRACKING_MODE !== 'on'
        ) {
            console.log('vue - Skip GTM logEvent', {
                event: eventName,
                ...payload,
            });
            return;
        }

        if (typeof window === 'undefined') {
            return;
        }

        try {
            if (!window.dataLayer) {
                console.warn('vue - GTM: dataLayer is not available');
                return;
            }

            window.dataLayer.push({
                event: eventName,
                time: new Date().toISOString(),
                ...payload,
            });
        } catch (e) {
            console.error('GTM logger error:', e);
        }
    },
};
